module.exports = __webpack_public_path__ + "img/Tennis.fbfaf6c.webp";